import React, { Component, ReactNode } from 'react';

import './download-messaging.less';

interface Props {
  children: Children;
}

interface Children {
  title: ReactNode;
  message?: ReactNode;
}

class DetailsMessaging extends Component<Props> {
  render() {
    const message = this.props.children.message ? (
      <div className="downloadMessaging-message">
        {this.props.children.message}
      </div>
    ) : null;

    return (
      <div className="downloadMessaging">
        <h2 className="downloadMessaging-title mt-0">
          {this.props.children.title}
        </h2>

        {message}
      </div>
    );
  }
}

export default DetailsMessaging;
